import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const SkeletonStyles = makeStyles((theme: Theme) =>
  createStyles({
    hideOnMobile: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    hideOnDesktop: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
  }),
);
